import { render, staticRenderFns } from "./RoleSettings.vue?vue&type=template&id=08c14dfc&scoped=true&"
import script from "./RoleSettings.vue?vue&type=script&lang=ts&"
export * from "./RoleSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c14dfc",
  null
  
)

export default component.exports